/* eslint-disable jsx-a11y/alt-text */
import { AppCSS, Spacer, TxtInput, ChkInputBox } from "../../../../components";
import { Lbl } from "../../../../components/labels";
import { ColDiv, RowDiv } from "../../../../components/misc/misc.styled";

import * as React from "react";
import { Container } from "../../../../globalstyled";

import { Autocomplete, Box, TextField, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import plusIcon from "../../../../images/PlusIcon.png";
import editIcon from "../../../../images/EditIcon.png";
import UpArrowIcon from "../../../../images/UploadIcon.png";
import DownArrowIcon from "../../../../images/DownloadIcon.png";
import searchIcon from "../../../../images/searchIcon.png";

import LeadsTableHeaderCard from "../../../../components/table/CustomTableHeaderCard";
import ContractorDrawer from "../SideDrawer/index";
import TableViewDetails from "../../../../components/table/TableViewDetails";
import CancelAndSubmitButtons from "../ItemCreationComponent/SubmitAndCancelButton";
import {
  FormTitleTypography,
  StandardIcon,
  ArrowIcon,
} from "../itemCreation.styled";
import TableWithoutHeader from "../../../../components/table/CustomTableBodyCardWithoutHeader";

import LeadsTableBodyCard from "../../../../components/table/CustomTableBodyCard";
import {
  FILE_TABLE_HEADER_LIST,
  LABOR_ITEMS_TABLE_HEADER_LIST,
} from "../../../../contants/dashboardHeader";

import {
  ContractorFile,
  Contractors,
  LaborItems,
  LaborItemsForm,
  LaborMeasurements,
  MaterialMeasurements,
  ProductSystem,
  ProductSystemForMiscField,
} from "../../../../redux/types/creation";
import { useState, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { logEvent, ITEM_CREATION_EVENTS } from "../../../../utils/amplitude";
import { SFileUpload } from "../../../../components/input/input.styled";
import { FileOpen } from "@mui/icons-material";
import { NumericFormat } from "react-number-format";
import SideDrawerHeader from "../SideDrawer/SideDrawerHeader";
import SearchAndCreateComponent from "../ItemCreationComponent/SearchAndCreateComponent";
import Pagination from "../ItemCreationComponent/Pagination";
import ViewRowDetailsDrawer from "../ItemCreationComponent/ViewFieldDetails";
import {
  LABOR_ITEMS_DRAWER_DETAILS,
  SELECT_CONTRACTOR_FILETYPE,
} from "../../../../contants/itemsCreation";
import EmptyTable from "../../../../components/table/EmptyTable";
import {
  ContractorFileInput,
  CreateLaborInput,
  CreateUploadFileInput,
} from "../../../../types/graphQlQuery.interface";
import { uploadImage } from "../../../../redux/api/common";
import {
  useArchiveLabor,
  useCreateLabor,
  useUpdateLabor,
} from "../../../../apolloClient/hooks/itemCreation/createHooks";
import { useCreateUploadUrl } from "../../../../apolloClient/hooks/general/createHook";
import { useDeleteLaborVariant } from "../../../../apolloClient/hooks/itemCreation/createHooks";
import { LaborVariant } from "../../../../redux/types/creation";
import { CreateLaborVariantInput, UpdateLaborVariantInput } from "../../../../types/graphQlQuery.interface";
import { extractCheckedIds } from "../../../../utils";
import FileUploadTable from "../ItemCreationComponent/FileUploadTable";
import ProductSystemParentIdsTable from "../ItemCreationComponent/ProductSystemParentIdsTable";
import ConfirmationDialog from "../../../../components/dialogue/ConfirmationDialog";

interface LaborItemsTableProps {
  laborItemsData: LaborItems[];
  refetchLabor?: Function;
  productsIds?: ProductSystem[];
  contractors?: Contractors[];
  // materialMeasurements?: MaterialMeasurements[];
  labourMeasurements?: LaborMeasurements[];
  permissions?: boolean;
}

export const LaborItemsTable: React.FC<LaborItemsTableProps> = ({
  laborItemsData,
  refetchLabor,
  productsIds,
  contractors,
  // materialMeasurements,
  labourMeasurements,
  permissions,
}) => {


  const [page, setPage] = React.useState(0);
  const [rowsPerPage] = React.useState(8);
  const [keyword, setKeyword] = React.useState("");

  const inputRef = React.useRef<HTMLInputElement>(null);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [openRowDetailsDrawer, setOpenRowDetailsDrawer] =
    React.useState<boolean>(false);

  const [photoFormDataArr, setPhotoFormDataArr] = React.useState<
    ContractorFileInput[]
  >([]);

  const [openPhotoFormDrawer, setOpenPhotoFormDrawer] = React.useState(false);

  const [viewRowDetailsData, setViewRowDetailsData] =
    useState<LaborItems | null>(null);

  const [showProductSystemParent, setShowProductSystemParent] =
    useState<boolean>(false);

  const [checkboxStates, setCheckboxStates] = useState<{
    [key: number]: boolean;
  }>({});

  const [laborItemsFormField, setLaborItemsFormField] =
    useState<LaborItemsForm>({
      description: "",
      price: null,
      measurementUnit: "",
      coverageAmount: null,
      contractorId: null,
      measurementId: null,
      parentIds: [],
      // files: [],
    });

  const [laborPhotoFormField, setLaborPhotoFormField] =
    useState<ContractorFileInput>({
      name: "",
      description: "",
      fileType: null,
      url: "",
    });

  const [laborVariants, setLaborVariants] = useState<LaborVariant[]>([]);
  const [openVariantFormDrawer, setOpenVariantFormDrawer] = useState(false);
  const [openSelectVariantDrawer, setOpenSelectVariantDrawer] = useState(false);
  const [isEditVariant, setIsEditVariant] = useState(false);
  const [variantToDelete, setVariantToDelete] = useState<LaborVariant | null>(null);
  const [openUnlinkDialog, setOpenUnlinkDialog] = useState(false);
  const [openPermDeleteDialog, setOpenPermDeleteDialog] = useState(false);
  const [searchVariantQuery, setSearchVariantQuery] = useState("");
  const [variantFormField, setVariantFormField] = useState<LaborVariant>({
    id: -1,
    productSystemId: 0,
    price: null,
    description: "",
    measurementUnit: "",
    coverageAmount: null,
  });

  const { deleteLaborVariant } = useDeleteLaborVariant();

  const allExistingVariants = React.useMemo(() => {
    const variantsMap = new Map<number, LaborVariant>();
    laborItemsData?.forEach(item => {
      item.variants?.forEach(v => {
        if (!variantsMap.has(v.id)) {
          variantsMap.set(v.id, v);
        }
      });
    });
    return Array.from(variantsMap.values());
  }, [laborItemsData]);

  const [laborEditPhotoDetails, setLaborEditPhotoDetails] =
    useState<ContractorFileInput>({
      name: "",
      description: "",
      fileType: null,
      url: "",
    });

  const fileRef = useRef<HTMLInputElement>(null);
  const [uploadUrl, setUploadUrl] = useState("");
  const [isEditPhotoDetails, setIsEditPhotoDetails] = useState<boolean>(false);
  const [fileUrl, setFileUrl] = useState<string>("");

  const truncateText = (text: string, length: number) => {
    if (!text) return ""; // Return empty string if no text
    return text.length > length ? text.substring(0, length) + "..." : text;
  };

  const { createLabor } = useCreateLabor();
  const { updateLabor } = useUpdateLabor();
  const { archiveLabor } = useArchiveLabor();

  const [openArchieveDialog, setOpenArchieveDialog] = useState(false);
  const [selectedLabor, setSelectedLabor] = useState<LaborItems | null>(null);

  const handleArchive = (row: LaborItems) => {
    setSelectedLabor(row);
    setOpenArchieveDialog(true);
  };

  const confirmArchieve = async () => {
    if (selectedLabor) {
      const success = await archiveLabor(selectedLabor.id);
      if (success) {
        toast(`Labor Archived!`, { type: "error" });
        logEvent(ITEM_CREATION_EVENTS.LABOR_ITEM_ARCHIVED, { item_id: selectedLabor.id, item_description: selectedLabor.description, timestamp: new Date().toISOString() });
        refetchLabor();
      } else {
        toast(`Failed to Archive Labor`);
      }
      setOpenArchieveDialog(false);
      setSelectedLabor(null);
    }
  };

  const cancelArchieve = () => {
    setOpenArchieveDialog(false);
    setSelectedLabor(null);
  };

  const { createUploadUrl } = useCreateUploadUrl();

  const [selectedLaborItem, setSelectedLaborItem] =
    React.useState<LaborItems | null>(null);

  const viewRowDetails = (rowData: LaborItems) => {
    setViewRowDetailsData(rowData);
    handleViewRowDetailsDrawerOpen();
  };

  const handleFileChange = (value: string, name: string) => {
    setLaborPhotoFormField((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const getUplaodUrl = async () => {
    const input: CreateUploadFileInput = {
      contentType: "image/jpeg",
    };

    const success = await createUploadUrl(input);
    if (success) {
      setUploadUrl(success.url);
      setFileUrl(success.fileName);
      return;
    } else {
      console.error("Failed to create Upload url.");
    }
  };

  const handleOpenFileDrawer = () => {
    setOpenPhotoFormDrawer(true);
    if (isEditPhotoDetails) {
      setLaborPhotoFormField({
        name: "",
        description: "",
        url: "",
        fileType: null,
      });
      setIsEditPhotoDetails(false);
    }
  };

  const handleSelectFileType = (event, selectedFileType) => {
    if (selectedFileType) {
      setLaborPhotoFormField((prevItem) => ({
        ...prevItem,
        fileType: selectedFileType.label,
      }));
    }
  };

  const handleCancelFileForm = () => {
    setOpenPhotoFormDrawer(false);
    setUploadUrl("");
    setIsEditPhotoDetails(false);
    setLaborPhotoFormField({
      name: "",
      description: "",
      url: "",
      fileType: null,
    });
  };

  const handlePhotoFormData = async () => {
    const file = fileRef.current?.files[0];

    const validationRules = [
      {
        condition: !laborPhotoFormField.name,
        message: "File name is required",
      },
      {
        condition: !laborPhotoFormField.description,
        message: "File description is required",
      },
      {
        condition: !laborPhotoFormField.fileType,
        message: "File fileType is required",
      },
      {
        condition: !file,
        message: "A file have not been selected",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    try {
      const result = await uploadImage(uploadUrl, file);
      if (result.success) {
        let photoFormData: ContractorFileInput = {
          name: laborPhotoFormField.name,
          description: laborPhotoFormField.description,
          url: fileUrl,
          fileType: laborPhotoFormField.fileType,
        };

        setPhotoFormDataArr((prevPhotoFormData) => [
          ...prevPhotoFormData,
          photoFormData,
        ]);

        setLaborPhotoFormField({
          name: "",
          description: "",
          url: "",
          fileType: null,
        });
        setOpenPhotoFormDrawer(false);
        setOpenPhotoFormDrawer(false);
        setUploadUrl("");
      }
    } catch (error) {
      console.error("Error uploading image ", error);
    }
  };

  const handleSubmitEditPhotoFormData = async () => {
    const file = fileRef.current?.files[0];

    try {
      if (file) {
        const result = await uploadImage(uploadUrl, file);
        if (result.success) {
          let photoFormData: ContractorFileInput = {
            name: laborPhotoFormField.name,
            description: laborPhotoFormField.description,
            url: fileUrl,
            fileType: laborPhotoFormField.fileType,
          };

          const updatedPhotoFormDataArr = photoFormDataArr.filter(
            (photoData) => photoData.url !== laborEditPhotoDetails.url
          );

          updatedPhotoFormDataArr.push(photoFormData);

          setPhotoFormDataArr(updatedPhotoFormDataArr);

          setLaborPhotoFormField({
            name: "",
            description: "",
            url: "",
            fileType: null,
          });
          setOpenPhotoFormDrawer(false);
          setUploadUrl("");
          setIsEditPhotoDetails(false);
        }
      } else {
        let photoFormData: ContractorFileInput = {
          name: laborPhotoFormField.name,
          description: laborPhotoFormField.description,
          url: laborEditPhotoDetails.url,
          fileType: laborPhotoFormField.fileType,
        };

        const updatedPhotoFormDataArr = photoFormDataArr.filter(
          (photoData) => photoData.url !== laborEditPhotoDetails.url
        );

        updatedPhotoFormDataArr.push(photoFormData);

        setPhotoFormDataArr(updatedPhotoFormDataArr);

        setLaborPhotoFormField({
          name: "",
          description: "",
          url: "",
          fileType: null,
        });
        setOpenPhotoFormDrawer(false);
        setUploadUrl("");
        setIsEditPhotoDetails(false);
      }
    } catch (error) {
      console.error("Error uploading image ", error);
    }
  };

  const handleViewRowDetailsDrawerOpen = () => {
    setOpenRowDetailsDrawer(true);
  };

  const handleViewRowDetailsDrawerClose = () => {
    setOpenRowDetailsDrawer(false);
  };

  const handleSelectContractorParentId = (event, selectedContractor) => {
    if (selectedContractor) {
      setLaborItemsFormField((prevItem) => ({
        ...prevItem,
        contractorId: selectedContractor.id,
      }));
    }
  };

  const getContractorParentIdsOptions = (
    sampleDataArray: any[]
  ): { id: number; label: string }[] => {
    return sampleDataArray?.map((item) => ({ id: item.id, label: item.name }));
  };

  const handleSelectLaborMeasurementParentId = (event, selectedMeasurement) => {
    if (selectedMeasurement) {
      setLaborItemsFormField((prevItem) => ({
        ...prevItem,
        measurementId: selectedMeasurement.id,
      }));
    }
  };

  const getLaborMeasurementParentIdsOptions = (
    sampleDataArray: any[]
  ): { id: number; label: string }[] => {
    return sampleDataArray.map((item) => ({ id: item.id, label: item.name }));
  };

  const handleChange = (value: string, name: string) => {
    setLaborItemsFormField((prevItem) => ({
      ...prevItem,
      [name]: value,
    }));
  };

  const handleSearchIconClick = () => {
    if (inputRef && inputRef.current) {
      inputRef.current.focus();
    }
  };

  const filterLaborItems = () => {
    if (keyword.length > 0 && Array.isArray(laborItemsData)) {
      return laborItemsData.filter((item) => {
        const laborDescription = `${item.description}`.toLowerCase();
        const laborPrice = `${item.price}`.toLowerCase();
        const laborCoverageAmount = `${item.coverageAmount}`.toLowerCase();
        const laborMeasurementUnit = `${item.measurementUnit}`.toLowerCase();
        const laborContractorId = `${item.contractorId}`.toLowerCase();

        return (
          laborDescription.includes(keyword.toLowerCase()) ||
          laborPrice.includes(keyword.toLowerCase()) ||
          laborCoverageAmount.includes(keyword.toLowerCase()) ||
          laborMeasurementUnit.includes(keyword.toLowerCase()) ||
          laborContractorId.includes(keyword.toLowerCase())
        );
      });
    }
    return laborItemsData;
  };

  const goToPreviousPage = () => {
    setPage((prevPage) => Math.max(prevPage - 1, 0));
  };

  const goToNextPage = () => {
    setPage((prevPage) =>
      Math.min(
        prevPage + 1,
        Math.ceil(filterLaborItems().length / rowsPerPage) - 1
      )
    );
  };

  const handleDrawerOpen = () => {
    setOpenDrawer(true);
    setSelectedLaborItem(null); // Clear selected labor item
    setLaborVariants([]);
    setLaborItemsFormField({
      description: "",
      price: null,
      measurementUnit: "",
      coverageAmount: null,
      contractorId: null,
      measurementId: null,
      parentIds: [],
    }); // Reset form fields
    setCheckboxStates({}); 
    setShowProductSystemParent(false); 
  };

  const handleDrawerClose = () => {
    setOpenDrawer(false);
    setSelectedLaborItem(null);
  };

  const handleEditClick = (laborItem: LaborItems) => {
    setSelectedLaborItem(laborItem);
    setLaborVariants(laborItem.variants || []);
    setLaborItemsFormField({
      description: laborItem.description,
      price: laborItem.price,
      measurementUnit: laborItem.measurementUnit,
      coverageAmount: laborItem.coverageAmount,
      contractorId: laborItem.contractorId || null,
      measurementId: laborItem.measurementId || null,
      parentIds: [],
    });
    setCheckboxStates(
      (laborItem.parents || []).reduce((acc, parent) => {
        if (parent.id) {
          acc[parent.id] = true;
        }
        return acc;
      }, {} as { [key: number]: boolean })
    );
    setOpenDrawer(true);
  };

  const onTapSubmitForm = async () => {
    const validationRules = [
      {
        condition: !laborItemsFormField.description,
        message: "Please Enter the labor item description",
      },
      {
        condition: !laborItemsFormField.price,
        message: "Please Enter the labor price",
      },
      {
        condition: !laborItemsFormField.measurementUnit,
        message: "Please Enter the measurement unit",
      },
      {
        condition: !laborItemsFormField.coverageAmount,
        message: "Please Enter the coverage amount",
      },
      {
        condition: !laborItemsFormField.contractorId,
        message: "Please Enter the contractor parent id",
      },
      {
        condition: !laborItemsFormField.measurementId,
        message: "Please Enter the labor measurement parent id",
      },
      {
        condition: !extractCheckedIds(checkboxStates).length,
        message: "Please select a minimum of one product system!",
      },
    ];

    for (const rule of validationRules) {
      if (rule.condition) {
        toast(rule.message, {
          type: "error",
          position: "top-left",
          className: "toast-message",
        });
        return;
      }
    }

    const checkedParentIds = extractCheckedIds(checkboxStates);

    const newVariants: CreateLaborVariantInput[] = laborVariants
      .filter(v => v.id < 0)
      .map(v => ({
        productSystemId: v.productSystemId,
        price: v.price || 0,
        description: v.description,
        measurementUnit: v.measurementUnit,
        coverageAmount: v.coverageAmount || 0,
      }));
      
    const updateVariants: UpdateLaborVariantInput[] = laborVariants
      .filter(v => {
        if (v.id <= 0) return false;
        const original = allExistingVariants.find(org => org.id === v.id);
        if (!original) return false; 
        return (
          v.price !== original.price ||
          v.description !== original.description ||
          v.measurementUnit !== original.measurementUnit ||
          v.coverageAmount !== original.coverageAmount
        );
      })
      .map(v => ({
        id: v.id,
        price: v.price || 0,
        description: v.description,
        measurementUnit: v.measurementUnit,
        coverageAmount: v.coverageAmount || 0,
      }));

    const variantIds = laborVariants.filter(v => v.id > 0).map(v => v.id);

    if (selectedLaborItem) {
      // Edit mode
      const input = {
        id: selectedLaborItem.id,
        description: laborItemsFormField.description,
        price: laborItemsFormField.price,
        measurementUnit: laborItemsFormField.measurementUnit,
        coverageAmount: laborItemsFormField.coverageAmount,
        contractorId: laborItemsFormField.contractorId,
        measurementId: laborItemsFormField.measurementId,
        parentIds: checkedParentIds,
        newVariants: newVariants.length > 0 ? newVariants : undefined,
        updateVariants: updateVariants.length > 0 ? updateVariants : undefined,
        variantIds: variantIds,
      };

      const success = await updateLabor(input);
      if (success) {
        toast("Labor item updated successfully.", {
          type: "success",
          className: "toast-message",
          position: "top-center",
        });
        logEvent(ITEM_CREATION_EVENTS.LABOR_ITEM_UPDATED, { item_id: selectedLaborItem.id, item_description: laborItemsFormField.description, timestamp: new Date().toISOString() });
        refetchLabor();
        handleDrawerClose();
        setLaborItemsFormField({
          description: "",
          price: null,
          measurementUnit: "",
          coverageAmount: null,
          contractorId: null,
          measurementId: null,
          parentIds: [],
        });
        setCheckboxStates({});
        setSelectedLaborItem(null);
        return;
      } else {
        console.error("Failed to update labor item.");
      }
    } else {
      // Create mode
      const input: CreateLaborInput = {
        description: laborItemsFormField.description,
        price: laborItemsFormField.price,
        measurementUnit: laborItemsFormField.measurementUnit,
        coverageAmount: laborItemsFormField.coverageAmount,
        contractorId: laborItemsFormField.contractorId,
        measurementId: laborItemsFormField.measurementId,
        parentIds: checkedParentIds,
        newVariants: newVariants.length > 0 ? newVariants : undefined,
        variantIds: variantIds.length > 0 ? variantIds : undefined,
      };

      const success = await createLabor(input);
      if (success) {
        toast("Labor item created successfully.", {
          type: "success",
          className: "toast-message",
          position: "top-center",
        });
        logEvent(ITEM_CREATION_EVENTS.LABOR_ITEM_CREATED, { item_description: laborItemsFormField.description, timestamp: new Date().toISOString() });
        refetchLabor();
        handleDrawerClose();
        setLaborItemsFormField({
          description: "",
          price: null,
          measurementUnit: "",
          coverageAmount: null,
          contractorId: null,
          measurementId: null,
          parentIds: [],
        });
        setCheckboxStates({});
        return;
      } else {
        console.error("Failed to create labor item.");
      }
    }
  };

  const createLaborItemsForm = () => {
    return (
      <ContractorDrawer open={openDrawer} onClose={handleDrawerClose}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={handleDrawerClose}
            labelTitle={
              selectedLaborItem
                ? "Edit labor pricing"
                : "Create new labor pricing"
            }
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              <ColDiv
                style={{
                  gap: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  <FormTitleTypography>
                    Labor pricing description
                  </FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter description"
                  onChange={handleChange}
                  required={true}
                  value={laborItemsFormField.description}
                  name="description"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  <FormTitleTypography>Price</FormTitleTypography>
                </Box>
                <TxtInput
                  type={"number"}
                  placeholder="Enter labor price"
                  onChange={handleChange}
                  required={true}
                  value={laborItemsFormField.price}
                  name="price"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  <FormTitleTypography>Measurement Unit</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter unit"
                  onChange={handleChange}
                  required={true}
                  value={laborItemsFormField.measurementUnit}
                  name="measurementUnit"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  <FormTitleTypography>Coverage Amount</FormTitleTypography>
                </Box>
                <TxtInput
                  type={"number"}
                  placeholder="Enter amount"
                  onChange={handleChange}
                  required={true}
                  value={laborItemsFormField.coverageAmount}
                  name="coverageAmount"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />
                <FormTitleTypography
                  style={{
                    display: "felx",
                    width: "60%",
                    justifyContent: "start",
                    textAlign: "start",
                  }}
                >
                  Select Associated Contractor
                </FormTitleTypography>
                <Box
                  sx={{
                    width: "96%",
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    background: "inherit",
                    borderRadius: "10px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "end",
                      width: "100%",
                    }}
                  >
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={getContractorParentIdsOptions(contractors)}
                      sx={{ width: "100%" }}
                      onChange={handleSelectContractorParentId}
                      value={
                        laborItemsFormField.contractorId
                          ? {
                              id: laborItemsFormField.contractorId,
                              label:
                                contractors?.find(
                                  (contractor) =>
                                    contractor.id ===
                                    laborItemsFormField.contractorId
                                )?.name || "",
                            }
                          : null
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="" />
                      )}
                    />
                  </Box>
                </Box>
                <FormTitleTypography
                  style={{
                    display: "felx",
                    width: "60%",
                    justifyContent: "start",
                    textAlign: "start",
                  }}
                >
                  Select Associated Labor Measurement
                </FormTitleTypography>
                <Box
                  sx={{
                    width: "96%",
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    background: "inherit",
                    borderRadius: "10px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "end",
                      width: "100%",
                    }}
                  >
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={getLaborMeasurementParentIdsOptions(
                        labourMeasurements
                      )}
                      sx={{ width: "100%" }}
                      onChange={handleSelectLaborMeasurementParentId}
                      value={
                        laborItemsFormField.measurementId
                          ? {
                              id: laborItemsFormField.measurementId,
                              label:
                                labourMeasurements?.find(
                                  (measurement) =>
                                    measurement.id ===
                                    laborItemsFormField.measurementId
                                )?.name || "",
                            }
                          : null
                      }
                      renderInput={(params) => (
                        <TextField {...params} label="" />
                      )}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "10px",
                  }}
                >
                  <Lbl
                    title="Associated product systems"
                    size={16}
                    width={80}
                    bold={600}
                  />
                </Box>
                <Box
                  sx={{
                    width: "96%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "inherit",
                    borderRadius: "10px",
                    border: "1px solid rgba(173, 173, 173, 1)",
                    height: "fit-content",
                    minHeight: "50px",
                    paddingY: "10px",
                  }}
                  onClick={() =>
                    setShowProductSystemParent(!showProductSystemParent)
                  }
                >
                  <RowDiv
                    style={{
                      width: "100%",
                      paddingLeft: "20px",
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        width: "60%",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <Lbl
                        title="Select associated product systems"
                        size={16}
                        mobileFontSize={16}
                        isFullWidth={true}
                      />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        width: "40%",
                        alignItems: "center",
                        justifyContent: "end",
                        paddingRight: "20px",
                      }}
                    >
                      {showProductSystemParent ? (
                        <ArrowIcon src={UpArrowIcon} />
                      ) : (
                        <ArrowIcon src={DownArrowIcon} />
                      )}
                    </Box>
                  </RowDiv>

                  {showProductSystemParent && (
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        cursor: "pointer",
                        justifyContent: "center",
                        alignItems: "start",
                        width: "100%",
                        paddingX: "20px",
                      }}
                    >
                      {productsIds.map((item) => (
                        <Box
                          key={`checkProductsSystemParent ${item.id}`}
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            cursor: "pointer",
                            justifyContent: "start",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <ChkInputBox
                            onChange={(value: boolean) => {
                              setCheckboxStates((prevCheckboxStates) => ({
                                ...prevCheckboxStates,
                                [item.id]: value,
                              }));
                              setShowProductSystemParent(true);
                            }}
                            placeholder=""
                            width={50}
                            marginTop={0}
                            marginBottom={0}
                            height={20}
                            background="inherit"
                            checked={checkboxStates[item.id] || false}
                          />
                          <Typography>{item.name}</Typography>
                        </Box>
                      ))}
                    </Box>
                  )}
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "20px",
                    width: "100%",
                  }}
                >
                  <FormTitleTypography>Labor Variants</FormTitleTypography>
                  <Box sx={{ display: 'flex', gap: '10px' }}>
                    <Box
                      component="button"
                      type="button"
                      onClick={() => {
                        setIsEditVariant(false);
                        setVariantFormField({
                          id: -new Date().getTime(),
                          productSystemId: (extractCheckedIds(checkboxStates) || [])[0] || 0,
                          price: null,
                          description: "",
                          measurementUnit: "",
                          coverageAmount: null,
                        });
                        setOpenVariantFormDrawer(true);
                      }}
                      sx={{
                        padding: "6px 12px",
                        borderRadius: "8px",
                        fontSize: "12px",
                        fontWeight: 600,
                        cursor: "pointer",
                        backgroundColor: "#4b87ed",
                        color: "white",
                        border: "none",
                      }}
                    >
                      + Create Variant
                    </Box>
                    <Box
                      component="button"
                      type="button"
                      onClick={() => setOpenSelectVariantDrawer(true)}
                      sx={{
                        padding: "6px 12px",
                        borderRadius: "8px",
                        fontSize: "12px",
                        fontWeight: 600,
                        cursor: "pointer",
                        backgroundColor: "#10b981",
                        color: "white",
                        border: "none",
                      }}
                    >
                      Search Existing
                    </Box>
                  </Box>
                </Box>
                <TableContainer component={Paper} elevation={0} sx={{ border: "1px solid #e0e0e0", borderRadius: "8px", mt: 2, mb: 2 }}>
                  <Table size="small">
                    <TableHead sx={{ backgroundColor: "#f9fafb" }}>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 600, color: "#374151" }}>Description</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#374151" }}>Price</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#374151" }}>Unit</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#374151" }}>Coverage</TableCell>
                        <TableCell sx={{ fontWeight: 600, color: "#374151", textAlign: "right" }}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {laborVariants.length === 0 ? (
                        <TableRow>
                          <TableCell colSpan={5} align="center" sx={{ py: 3, color: "#6b7280" }}>
                            No variants associated.
                          </TableCell>
                        </TableRow>
                      ) : (
                        laborVariants.map((variant, vIdx) => (
                          <TableRow key={`variant-${vIdx}`} hover>
                            <TableCell>{variant.description}</TableCell>
                            <TableCell>${variant.price || 0}</TableCell>
                            <TableCell>{variant.measurementUnit || "-"}</TableCell>
                            <TableCell>{variant.coverageAmount || 0}</TableCell>
                            <TableCell align="right">
                              <Box sx={{ display: 'flex', gap: '15px', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <Box sx={{ cursor: 'pointer', color: '#4b87ed', fontSize: '13px', fontWeight: 600 }} onClick={() => {
                                  setIsEditVariant(true);
                                  setVariantFormField(variant);
                                  setOpenVariantFormDrawer(true);
                                }}>
                                  Edit
                                </Box>
                                <Box sx={{ cursor: 'pointer', color: '#ef4444', fontSize: '13px', fontWeight: 600 }} onClick={() => {
                                  setVariantToDelete(variant);
                                  setOpenUnlinkDialog(true);
                                }}>
                                  Remove
                                </Box>
                              </Box>
                            </TableCell>
                          </TableRow>
                        ))
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>

                {/* <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                    marginTop: "10px",
                  }}
                >
                  <FormTitleTypography>Files</FormTitleTypography>
                  <StandardIcon src={plusIcon} onClick={handleOpenFileDrawer} />
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    paddingY: "10px",
                  }}
                >
                  {photoFormDataArr.length > 0 && (
                    <LeadsTableHeaderCard
                      headers={FILE_TABLE_HEADER_LIST}
                      fontSize={"14px"}
                    />
                  )}
                  {photoFormDataArr.map((labor, laborIndex) => (
                    <TableWithoutHeader
                      key={`Labor file ${laborIndex}`}
                      containerWidth="100%"
                      bodyContent={[
                        {
                          text: `${laborIndex + 1}`,
                          width: "10%",
                          fontSize: "12px",
                        },
                        {
                          text: `${labor.name}`,
                          width: "15%",
                          fontSize: "12px",
                        },
                        {
                          text: `${labor.description}`,
                          width: "30%",
                          fontSize: "12px",
                        },
                        {
                          text: `${labor.fileType}`,
                          width: "20%",
                        },
                        {
                          text: (
                            <a
                              href={`${labor.url}`}
                              target="_blank"
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "start",
                                alignItems: "center",
                                fontSize: 15,
                                color: AppCSS.GLAS_BLUE,
                                backgroundColor: AppCSS.GREEN_MILD,
                                borderRadius: "10px",
                                padding: "5px",
                              }}
                              rel="noreferrer"
                              download={false}
                            >
                              <p>View File</p>
                            </a>
                          ),
                          width: "15%",
                        },
                        {
                          text: "",
                          width: "10%",
                          justifyContent: "end",
                          isAction: true,
                          actionComponent: (
                            <>
                              <Box
                                onClick={() => {
                                  handleEditPhotoFormData(labor);
                                }}
                                sx={{
                                  display: "flex",
                                  flexDirection: "row",
                                  paddingRight: "20px",
                                  cursor: "pointer",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <StandardIcon src={editIcon} />
                              </Box>
                            </>
                          ),
                        },
                      ]}
                    />
                  ))}
                </Box> */}
                <Spacer size={1} direction="col" />
              </ColDiv>
            </Box>
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={handleDrawerClose}
          onCreate={onTapSubmitForm}
          submitText={selectedLaborItem ? "Update" : "Create"}
        />
        <Spacer size={2} direction="col" />
      </ContractorDrawer>
    );
  };

  const createFileForm = () => {
    return (
      <ContractorDrawer
        open={openPhotoFormDrawer}
        onClose={() => {
          setOpenPhotoFormDrawer(false);
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            width: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={() => {
              setOpenPhotoFormDrawer(false);
            }}
            labelTitle={
              isEditPhotoDetails
                ? "Edit Photo Details"
                : "Add file to labor pricing"
            }
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
                marginBottom: "20px",
              }}
            >
              <ColDiv
                style={{
                  gap: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>File name</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter the file name"
                  onChange={handleFileChange}
                  required={true}
                  value={laborPhotoFormField.name}
                  name="name"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>File Description</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter file description"
                  onChange={handleFileChange}
                  required={true}
                  value={laborPhotoFormField.description}
                  name="description"
                  background="inherit"
                  borderColor="rgba(173, 173, 173, 1)"
                  borderRadius={10}
                  height={50}
                />

                <Box
                  sx={{
                    width: "96%",
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    background: "inherit",
                    borderRadius: "10px",
                    border: "1px solid rgba(173, 173, 173, 1)",
                  }}
                >
                  <FormTitleTypography
                    style={{
                      display: "felx",
                      width: "60%",
                      justifyContent: "start",
                      textAlign: "start",
                      paddingLeft: "10px",
                    }}
                  >
                    Select File Type
                  </FormTitleTypography>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "end",
                      width: "40%",
                    }}
                  >
                    <Autocomplete
                      disablePortal
                      id="combo-box-demo"
                      options={SELECT_CONTRACTOR_FILETYPE}
                      sx={{ width: "100%" }}
                      onChange={handleSelectFileType}
                      renderInput={(params) => (
                        <TextField {...params} label="" />
                      )}
                    />
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    cursor: "pointer",
                    justifyContent: "start",
                    alignItems: "center",
                    gap: "30px",
                    marginTop: "10px",
                  }}
                >
                  {" "}
                  <FormTitleTypography>Upload File</FormTitleTypography>
                </Box>

                <Box
                  sx={{
                    width: "96%",
                    marginX: "2%",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    background: AppCSS.GRAY_MILD,
                    borderRadius: "5px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "60%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Lbl title="Upload file" size={16} />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      width: "40%",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SFileUpload
                      style={{
                        border: uploadUrl === "" ? `3px solid #A9CBB7` : "none",
                        marginLeft: 10,
                        height: "35px",
                        width: "100px",
                      }}
                      onClick={() => {
                        if (fileRef.current) {
                          fileRef.current.click();
                        }
                      }}
                    >
                      <input
                        type="file"
                        id="file"
                        ref={fileRef}
                        onChange={() => {
                          if (uploadUrl === "") {
                            getUplaodUrl();
                          }
                        }}
                        accept={"image/png, image/jpeg, image/jpg,.pdf"}
                        style={{
                          display: "none",
                        }}
                      />
                      <FileOpen
                        titleAccess="Select File"
                        color="warning"
                        style={{
                          width: 32,
                          height: 32,
                          color: AppCSS.GLAS_GREEN,
                        }}
                      />
                    </SFileUpload>
                  </Box>
                </Box>
                <Spacer size={1} direction="col" />
              </ColDiv>
            </Box>
          </Box>
        </Box>

        <CancelAndSubmitButtons
          onCancel={handleCancelFileForm}
          onCreate={
            isEditPhotoDetails
              ? handleSubmitEditPhotoFormData
              : handlePhotoFormData
          }
          submitText={
            isEditPhotoDetails ? "Update file details" : "Add file details"
          }
        />
      </ContractorDrawer>
    );
  };

  const showLaborItemsRowDetails = () => {
    return (
      <ViewRowDetailsDrawer
        openDrawer={openRowDetailsDrawer}
        handleDrawerClose={handleViewRowDetailsDrawerClose}
        rowDetailsData={viewRowDetailsData}
        labelTitle="Labor items Details"
        rowArrayTableComponent={(value: ContractorFile[], key?: string) => (
          <FileUploadTable value={value} key={key} />
        )}
        rowArrayTableComponentTwo={(
          value: ProductSystemForMiscField[],
          key?: string
        ) => <ProductSystemParentIdsTable value={value} key={key} />}
        detailsOfRowToBeDisplay={LABOR_ITEMS_DRAWER_DETAILS}
      />
    );
  };

  const LaborItemsTable = () => {
    const paginatedData = filterLaborItems().slice(
      page * rowsPerPage,
      page * rowsPerPage + rowsPerPage
    );
    const totalPages = Math.ceil(filterLaborItems().length / rowsPerPage);

    return (
      <Box sx={{ width: "100%" }}>
        {/* Search and Create Button */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", md: "center" },
            gap: 2,
            mb: 3,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              backgroundColor: "white",
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              height: "44px",
              width: { xs: "100%", md: "320px" },
              transition: "border-color 0.2s, box-shadow 0.2s",
              "&:focus-within": {
                borderColor: "#4b87ed",
                boxShadow: "0 0 0 3px rgba(75, 135, 237, 0.1)",
              },
            }}
          >
            <Box
              component="img"
              src={searchIcon}
              sx={{ width: 16, height: 16, cursor: "pointer", margin: "0 12px" }}
              onClick={handleSearchIconClick}
            />
            <TxtInput
              placeholder="Search labor pricing"
              onChange={setKeyword}
              inputRef={inputRef}
              background="white"
              width="100%"
            />
          </Box>

          {permissions && (
            <Box
              component="button"
              onClick={() => handleDrawerOpen()}
              sx={{
                padding: "10px 20px",
                borderRadius: "8px",
                fontSize: "14px",
                fontWeight: 500,
                cursor: "pointer",
                transition: "all 0.2s",
                backgroundColor: "#4b87ed",
                color: "white",
                border: "none",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "#3a6fd8",
                },
              }}
            >
              + Create new labor item
            </Box>
          )}
        </Box>

        {/* Table */}
        <Box
          sx={{
            width: "100%",
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
            overflow: "hidden",
          }}
        >
          {/* Desktop Table Header */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              padding: "14px 20px",
              backgroundColor: "#f3f4f6",
              borderBottom: "1px solid #e5e7eb",
              fontWeight: 600,
              fontSize: 12,
              color: "#6b7280",
              textTransform: "uppercase",
              alignItems: "center",
            }}
          >
            <Box sx={{ width: "8%", minWidth: "50px" }}>ID</Box>
            <Box sx={{ width: "25%", minWidth: "100px" }}>Description</Box>
            <Box sx={{ width: "15%", minWidth: "80px" }}>Price</Box>
            <Box sx={{ width: "12%", minWidth: "70px" }}>Unit</Box>
            <Box sx={{ width: "15%", minWidth: "80px" }}>Coverage</Box>
            <Box sx={{ width: "25%", minWidth: "150px", textAlign: "right" }}>Actions</Box>
          </Box>

          {/* Table Body */}
          {filterLaborItems().length === 0 ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                padding: "48px 24px",
                textAlign: "center",
              }}
            >
              <Typography sx={{ fontSize: 15, color: "#6b7280", margin: 0 }}>
                No labor items available
              </Typography>
            </Box>
          ) : (
            paginatedData.map((laborItems, laborItemsIndex) => (
              <Box
                key={`labor-item-${laborItemsIndex}`}
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  alignItems: { xs: "flex-start", md: "center" },
                  padding: { xs: "14px 16px", md: "14px 20px" },
                  borderBottom: "1px solid #f0f0f0",
                  gap: { xs: 1, md: 0 },
                  width: "100%",
                  "&:hover": {
                    backgroundColor: "#f8f9fa",
                  },
                  "&:last-child": {
                    borderBottom: "none",
                  },
                }}
              >
                {/* ID */}
                <Box sx={{ width: { xs: "100%", md: "8%" }, minWidth: { md: "50px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    ID
                  </Typography>
                  <Typography sx={{ fontSize: 14, fontWeight: 500, color: "#1a1a2e" }}>
                    {laborItems.id}
                  </Typography>
                </Box>

                {/* Description */}
                <Box sx={{ width: { xs: "100%", md: "25%" }, minWidth: { md: "100px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Description
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    {truncateText(laborItems.description, 30)}
                  </Typography>
                </Box>

                {/* Price */}
                <Box sx={{ width: { xs: "100%", md: "15%" }, minWidth: { md: "80px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Price
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    <NumericFormat
                      displayType="text"
                      value={laborItems.price}
                      prefix="$"
                      thousandSeparator
                    />
                  </Typography>
                </Box>

                {/* Unit */}
                <Box sx={{ width: { xs: "100%", md: "12%" }, minWidth: { md: "70px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Unit
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    {laborItems.measurementUnit}
                  </Typography>
                </Box>

                {/* Coverage */}
                <Box sx={{ width: { xs: "100%", md: "15%" }, minWidth: { md: "80px" } }}>
                  <Typography
                    sx={{
                      display: { xs: "block", md: "none" },
                      fontSize: 11,
                      fontWeight: 500,
                      color: "#9ca3af",
                      textTransform: "uppercase",
                      letterSpacing: 0.5,
                      marginBottom: "2px",
                    }}
                  >
                    Coverage
                  </Typography>
                  <Typography sx={{ fontSize: 14, color: "#374151" }}>
                    <NumericFormat
                      displayType="text"
                      value={laborItems.coverageAmount}
                      thousandSeparator
                    />
                  </Typography>
                </Box>

                {/* Actions */}
                <Box
                  sx={{
                    width: { xs: "100%", md: "25%" },
                    minWidth: { md: "150px" },
                    display: "flex",
                    justifyContent: { xs: "flex-start", md: "flex-end" },
                    gap: 1,
                    flexWrap: "wrap",
                    marginTop: { xs: 1, md: 0 },
                  }}
                >
                  <Box
                    component="button"
                    onClick={() => viewRowDetails(laborItems)}
                    sx={{
                      padding: "8px 16px",
                      borderRadius: "6px",
                      fontSize: "13px",
                      fontWeight: 500,
                      cursor: "pointer",
                      transition: "all 0.2s",
                      backgroundColor: "#e5e7eb",
                      color: "#374151",
                      border: "none",
                      "&:hover": {
                        backgroundColor: "#d1d5db",
                      },
                    }}
                  >
                    View
                  </Box>
                  {permissions && (
                    <>
                      <Box
                        component="button"
                        onClick={() => handleEditClick(laborItems)}
                        sx={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          fontSize: "13px",
                          fontWeight: 500,
                          cursor: "pointer",
                          transition: "all 0.2s",
                          backgroundColor: "#e5e7eb",
                          color: "#374151",
                          border: "none",
                          "&:hover": {
                            backgroundColor: "#d1d5db",
                          },
                        }}
                      >
                        Edit
                      </Box>
                      <Box
                        component="button"
                        onClick={() => handleArchive(laborItems)}
                        sx={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          fontSize: "13px",
                          fontWeight: 500,
                          cursor: "pointer",
                          transition: "all 0.2s",
                          backgroundColor: "#fee2e2",
                          color: "#dc2626",
                          border: "none",
                          "&:hover": {
                            backgroundColor: "#fecaca",
                          },
                        }}
                      >
                        Archive
                      </Box>
                    </>
                  )}
                </Box>
              </Box>
            ))
          )}

          {/* Pagination */}
          {filterLaborItems().length > 0 && totalPages > 1 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: { xs: "center", md: "flex-end" },
                padding: "14px 20px",
                gap: 1,
                borderTop: "1px solid #f0f0f0",
                backgroundColor: "#fafafa",
              }}
            >
              <Box
                component="button"
                onClick={goToPreviousPage}
                disabled={page === 0}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page === 0 ? "#f3f4f6" : "#e5e7eb",
                  color: page === 0 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page === 0 ? "not-allowed" : "pointer",
                  "&:hover": page === 0 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                ← Prev
              </Box>
              <Typography sx={{ fontSize: 14, color: "#6b7280", margin: "0 8px" }}>
                Page {page + 1} of {totalPages}
              </Typography>
              <Box
                component="button"
                onClick={goToNextPage}
                disabled={page >= totalPages - 1}
                sx={{
                  px: 2,
                  py: 1,
                  border: "none",
                  borderRadius: "6px",
                  backgroundColor: page >= totalPages - 1 ? "#f3f4f6" : "#e5e7eb",
                  color: page >= totalPages - 1 ? "#9ca3af" : "#374151",
                  fontSize: 13,
                  fontWeight: 500,
                  cursor: page >= totalPages - 1 ? "not-allowed" : "pointer",
                  "&:hover": page >= totalPages - 1 ? {} : { backgroundColor: "#d1d5db" },
                }}
              >
                Next →
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    );
  };

  const renderVariantFormDrawer = () => {
    return (
      <ContractorDrawer open={openVariantFormDrawer} onClose={() => setOpenVariantFormDrawer(false)}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            width: "100%",
            height: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={() => setOpenVariantFormDrawer(false)}
            labelTitle={isEditVariant ? "Edit Variant" : "Create New Variant"}
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              flex: 1,
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                width: "100%",
                paddingX: "24px",
                paddingBottom: "24px",
              }}
            >
              <ColDiv style={{ gap: "10px" }}>
                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center" }}>
                  <FormTitleTypography>Product System</FormTitleTypography>
                </Box>
                <Autocomplete
                  options={productsIds?.map(p => ({ label: p.name, id: p.id })) || []}
                  value={{ id: variantFormField.productSystemId, label: productsIds?.find((p: any) => p.id === variantFormField.productSystemId)?.name || "" }}
                  onChange={(_, val) => setVariantFormField(prev => ({ ...prev, productSystemId: val?.id || 0 }))}
                  renderInput={(params) => (
                    <TextField 
                      {...params} 
                      placeholder="Select product system" 
                      size="small"
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px",
                          height: "50px",
                          borderColor: "rgba(173, 173, 173, 1)",
                        }
                      }}
                    />
                  )}
                  isOptionEqualToValue={(option, value) => option.id === value?.id}
                  disableClearable
                />

                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", marginTop: "10px" }}>
                  <FormTitleTypography>Description</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter description"
                  value={variantFormField.description}
                  onChange={(val) => setVariantFormField(prev => ({ ...prev, description: val }))}
                  background="inherit" borderColor="rgba(173, 173, 173, 1)" borderRadius={10} height={50} required={true}
                />

                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", marginTop: "10px" }}>
                  <FormTitleTypography>Price</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter price"
                  type="number"
                  value={String(variantFormField.price === null ? "" : variantFormField.price)}
                  onChange={(val) => setVariantFormField(prev => ({ ...prev, price: parseFloat(val) }))}
                  background="inherit" borderColor="rgba(173, 173, 173, 1)" borderRadius={10} height={50}
                />

                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", marginTop: "10px" }}>
                  <FormTitleTypography>Measurement Unit</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter unit"
                  value={variantFormField.measurementUnit || ""}
                  onChange={(val) => setVariantFormField(prev => ({ ...prev, measurementUnit: val }))}
                  background="inherit" borderColor="rgba(173, 173, 173, 1)" borderRadius={10} height={50}
                />

                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "start", alignItems: "center", marginTop: "10px" }}>
                  <FormTitleTypography>Coverage Amount</FormTitleTypography>
                </Box>
                <TxtInput
                  placeholder="Enter coverage"
                  type="number"
                  value={String(variantFormField.coverageAmount === null ? "" : variantFormField.coverageAmount)}
                  onChange={(val) => setVariantFormField(prev => ({ ...prev, coverageAmount: parseFloat(val) }))}
                  background="inherit" borderColor="rgba(173, 173, 173, 1)" borderRadius={10} height={50}
                />
              </ColDiv>

              <Box sx={{marginTop: '40px', display: 'flex', flexDirection: 'column', gap: '15px'}}>
                <CancelAndSubmitButtons
                  onCancel={() => setOpenVariantFormDrawer(false)}
                  onCreate={() => {
                    if (!variantFormField.description) {
                      toast("Description is required.", { type: "error" });
                      return;
                    }
                    if (isEditVariant) {
                      setLaborVariants(prev => prev.map(v => v.id === variantFormField.id ? variantFormField : v));
                      toast("Variant temporarily updated. Save pricing to apply.", { type: "success" });
                    } else {
                      setLaborVariants(prev => [...prev, variantFormField]);
                      toast("Variant temporarily added. Save pricing to apply.", { type: "success" });
                    }
                    setOpenVariantFormDrawer(false);
                  }}
                  submitText={isEditVariant ? "Update Variant" : "Add Variant"}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </ContractorDrawer>
    );
  };

  const renderSelectVariantDrawer = () => {
    return (
      <ContractorDrawer open={openSelectVariantDrawer} onClose={() => setOpenSelectVariantDrawer(false)}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "start",
            gap: "10px",
            width: "100%",
            height: "100%",
          }}
        >
          <SideDrawerHeader
            handleDrawerClose={() => setOpenSelectVariantDrawer(false)}
            labelTitle="Search & Select Existing Variants"
          />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              flex: 1,
              overflowY: "auto",
              paddingX: "24px",
              paddingBottom: "24px",
            }}
          >
            <Typography sx={{fontSize: 14, color: '#6b7280', mb: 2}}>Select from variants already existing in the system to link them to this labor pricing.</Typography>
            
            <Box sx={{ mb: 3 }}>
              <TxtInput
                placeholder="Search variants by description..."
                value={searchVariantQuery}
                onChange={(val) => setSearchVariantQuery(val)}
                background="inherit"
                borderColor="rgba(173, 173, 173, 1)"
                borderRadius={10}
                height={45}
              />
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              {allExistingVariants
                .filter(v => searchVariantQuery.trim() === "" || v.description.toLowerCase().includes(searchVariantQuery.toLowerCase()))
                .map(variant => (
                <Box key={`existing_var_` + variant.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 2, border: '1px solid #e0e0e0', borderRadius: '8px' }}>
                  <Box>
                    <Typography sx={{ fontWeight: 600, fontSize: 14 }}>{variant.description}</Typography>
                    <Typography sx={{ fontSize: 13, color: '#6b7280' }}>${variant.price || 0} / {variant.measurementUnit || "unit"}</Typography>
                  </Box>
                  <Box component="button" type="button" onClick={() => {
                    if (!laborVariants.some(v => v.id === variant.id)) {
                      setLaborVariants(prev => [...prev, variant]);
                      toast("Variant added!", {type: "success"});
                    } else {
                      toast("Variant is already added.", {type: "info"});
                    }
                  }} sx={{ padding: '6px 16px', borderRadius: '6px', background: '#e0e7ff', color: '#4f46e5', border: 'none', cursor: 'pointer', fontWeight: 600 }}>
                    Select
                  </Box>
                </Box>
              ))}
              {allExistingVariants.filter(v => searchVariantQuery.trim() === "" || v.description.toLowerCase().includes(searchVariantQuery.toLowerCase())).length === 0 && (
                <Typography sx={{ textAlign: 'center', color: '#9ca3af', mt: 4 }}>
                  {searchVariantQuery ? "No matching variants found." : "No variants found in the system yet."}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
      </ContractorDrawer>
    );
  };

  const laborItemsContainer = () => {
    return (
      <Box sx={{ width: "100%" }}>
        {Array.isArray(laborItemsData) && LaborItemsTable()}
        {createLaborItemsForm()}
        {showLaborItemsRowDetails()}
        {createFileForm()}
        {renderVariantFormDrawer()}
        {renderSelectVariantDrawer()}
      </Box>
    );
  };

  return (
    <>
      {laborItemsContainer()}
      <ConfirmationDialog
        open={openArchieveDialog}
        title="Confirm Archive"
        message={`Are you sure you want to Archive this Labor?`}
        onConfirm={confirmArchieve}
        onCancel={cancelArchieve}
      />
      <ConfirmationDialog
        open={openUnlinkDialog}
        title="Remove Variant"
        message="Are you sure you want to remove this variant from the list?"
        confirmText="Remove"
        cancelText="Cancel"
        onConfirm={() => {
          setOpenUnlinkDialog(false);
          if (variantToDelete && variantToDelete.id > 0) {
            setOpenPermDeleteDialog(true);
          } else if (variantToDelete) {
            setLaborVariants(prev => prev.filter(v => v.id !== variantToDelete.id));
            setVariantToDelete(null);
          }
        }}
        onCancel={() => {
          setOpenUnlinkDialog(false);
          setVariantToDelete(null);
        }}
      />
      <ConfirmationDialog
        open={openPermDeleteDialog}
        title="Permanently Delete Variant?"
        message={
          <Box>
            <Typography>Do you also want to permanently delete this variant from the entire system database? This action cannot be undone.</Typography>
            <Typography sx={{ mt: 2 }}>Click "Delete Globally" to permanently remove it, or "Keep in System" to just unlink it from this labor.</Typography>
          </Box>
        }
        confirmText="Delete Globally"
        cancelText="Keep in System"
        onConfirm={async () => {
          if (variantToDelete && variantToDelete.id > 0) {
            const success = await deleteLaborVariant(variantToDelete.id);
            if (success) { toast("Variant permanently deleted.", {type: "success"}); }
            setLaborVariants(prev => prev.filter(v => v.id !== variantToDelete.id));
          }
          setOpenPermDeleteDialog(false);
          setVariantToDelete(null);
        }}
        onCancel={() => {
          if (variantToDelete) {
            setLaborVariants(prev => prev.filter(v => v.id !== variantToDelete.id));
          }
          setOpenPermDeleteDialog(false);
          setVariantToDelete(null);
        }}
      />
    </>
  );
};
